import { Context } from '@sentry/react'

type FlowFormat = `[${Flow}:${string}]` // [flow:function/api call naming] e.g. [simulation:createProspect]
type CmsFormat = `[CMS:${string}:${string}]` // [CMS:page:function] e.g. [CMS:career:getStaticProps]
type LocationFormat = '[Geocode:fromAddress]'
type BetaFormat = `[BETA:${string}]`

export type IdentifierFormats = FlowFormat | CmsFormat | LocationFormat | BetaFormat | `[${string}]`

export type Logging<T extends IdentifierFormats> = {
  severity?: Severity // default is error
  identifier: T
  error: Error | string
  metaData?: Record<string, Context>
  criticality?: Criticality
  errorCode?: string // machine-readable response code, matched against HANDLED_ERRORS and set as a Sentry tag
  fingerprint?: string[] // overrides Sentry's default grouping, use to keep dynamic parts of the message out of the grouping
}

export type LoggingUser = {
  id?: string
  email: string
  name?: string
}

export enum Flow {
  ACCESS_RIGHTS = 'accessRights',
  AUTH = 'auth',
  CASES = 'cases',
  COMPLAINTS = 'complaints',
  CONTACTS = 'contacts',
  CONTRACT = 'contract',
  CONTRACTS = 'contracts',
  CUSTOMERS = 'customers',
  DISCOUNTS = 'discounts',
  EVENTS = 'events',
  FEEDBACK_WIDGETS = 'feedbackWidgets',
  METER_READINGS = 'meterReadings',
  METRICS = 'metrics',
  PRODUCERS = 'producers',
  PRODUCTS = 'products',
  PROSPECTS = 'prospects',
  REPORTS = 'reports',
  SALES = 'sales',
  SERVICE_CONTRACT = 'serviceContract',
  SURVEY = 'survey',
  TARIFFS = 'tariffs'
}

export enum Severity {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

export enum Criticality {
  CRITICAL = 'critical',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low'
}
